<template>
  <div>
    <div class="filter-row" style="text-align:center;">
      <div style="float:right">
      <Checkbox  v-model="showProject">显示项目</Checkbox>
      <Divider type="vertical"></Divider>
      <Button  type="primary" v-if="$menu.isPower('analysis', 'import')" size="small" @click="exportData"><Icon type="ios-download-outline"></Icon>导出</Button>
      </div>
      <Checkbox style="float:left" v-model="changeValue">调整后产值</Checkbox>
      <Button size="small" @click="lastYear"><Icon type="md-arrow-back"></Icon></Button>
      <DatePicker type="year" confirm :open="open" placeholder="Select year" style="width: 200px" @on-change="handleChange" @on-ok="handleOk">
        <a href="javascript:void(0)" @click="handleClick" style="font-size:16px">
            <Icon type="ios-calendar-outline"></Icon>
            <template v-if="year === ''">选择时间</template>
            <template v-else>{{ year }} 年</template>
        </a>
      </DatePicker>
      <Button size="small" @click="nextYear"><Icon type="md-arrow-forward"></Icon></Button>
    </div>
     <div class="ivu-table-wrapper">
       <div class="ivu-table ivu-table-default ivu-table-border">
        <div class="ivu-table-body ivu-table-overflowX">
          <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
           <colgroup>
             <col width="100">
             <col width="80">
             <col width="200">
             <template v-for="item in monthLen">
               <col width="100" :key="item+'_1'">
               <col width="100" :key="item+'_2'">
               <col width="100" :key="item+'_3'">
               <col width="100" :key="item+'_4'">
             </template>
           </colgroup>
             <thead>
               <tr>
                 <th class="ivu-table-column-center" rowspan="2"><div class="ivu-table-cell"><span class="">部门</span></div></th>
                 <th class="ivu-table-column-center" rowspan="2"><div class="ivu-table-cell"><span class="">负责人</span></div></th>
                 <th class="ivu-table-column-center" rowspan="2"><div class="ivu-table-cell"><span class="">项目名称</span></div></th>
                 <template v-for="item in monthLen">
                   <th class="ivu-table-column-center" :key="item" colspan="4" v-if="item==1"><div class="ivu-table-cell"><span class="">汇总</span></div></th>
                   <th class="ivu-table-column-center" :key="item" colspan="4" v-else><div class="ivu-table-cell"><span class="">{{item-1}} 月</span></div></th>
                 </template>
               </tr>
               <tr>
                 <template v-for="item in monthLen">
                   <th :key="item+'_1'" class="ivu-table-column-center" v-if="!changeValue">
                     <div class="ivu-table-cell"><span class="">产值</span></div>
                   </th>
                   <th :key="item+'_2'" class="ivu-table-column-center" v-if="changeValue">
                     <div class="ivu-table-cell"><span class="">调整后产值</span></div>
                   </th>
                   <th :key="item+'_5'" class="ivu-table-column-center">
                     <div class="ivu-table-cell"><span class="">项目报销</span></div>
                   </th>
                   <th :key="item+'_3'" class="ivu-table-column-center">
                     <div class="ivu-table-cell"><span class="">总成本</span></div>
                   </th>
                    
                   <th :key="item+'_4'" class="ivu-table-column-center">
                     <div class="ivu-table-cell"><span class="">毛利率</span></div>
                   </th>
                 </template>
               </tr>
             </thead>
             <tbody class="ivu-table-body ivu-table-overflowX">
               <template v-for="(item, index) in data">
                 <tr :key="index" class="ivu-table-row" :class="{'allcount': item.name=='汇总'}">
                  <td class="ivu-table-column-center" :rowspan="showProject?item.projects.length + 1:2"><div class="ivu-table-cell"><span>{{item.name}}</span></div></td>
                  <td class="ivu-table-column-center" :rowspan="showProject?item.projects.length + 1:2"><div class="ivu-table-cell"><span v-if="item.director">{{item.director.username}}</span></div></td>
                </tr>
               <template v-for="(pro, ind) in item.projects">
                <tr class="ivu-table-row" :class="{'allcount': item.name=='汇总'}" :key="index+ '_' + ind" v-if="(pro.name=='总计'||pro.name=='全部') || showProject">
                  <td class="ivu-table-column-center" :class="{'high-light': (pro.name=='总计'||pro.name=='全部')&&showProject}"><div class="ivu-table-cell"><span>{{pro.name}}</span></div></td>
                  <td class="ivu-table-column-center" v-if="!changeValue" :class="{'high-light': (pro.name=='总计'||pro.name=='全部')&&showProject}"><div class="ivu-table-cell"><span>{{pro.total_value|toFixed}} </span></div></td>
                  <td class="ivu-table-column-center" v-if="changeValue" :class="{'high-light': (pro.name=='总计'||pro.name=='全部')&&showProject}"><div class="ivu-table-cell"><span>{{(pro.total_value + pro.total_new_value)|toFixed}} </span></div></td>
                  <td class="ivu-table-column-center" :class="{'high-light': (pro.name=='总计'||pro.name=='全部')&&showProject}"><div class="ivu-table-cell"><span>{{pro.total_all_expense|toFixed}}</span></div></td>
                  <td class="ivu-table-column-center" :class="{'high-light': (pro.name=='总计'||pro.name=='全部')&&showProject}"><div class="ivu-table-cell"><span>{{pro.total_all_cost|toFixed}} </span></div></td>
                  <td class="ivu-table-column-center" :class="{'high-light': (pro.name=='总计'||pro.name=='全部')&&showProject}"><div class="ivu-table-cell"><span>{{grossMargin(pro.total_all_cost, pro.total_value, pro.total_new_value)}}</span></div></td>
                  <template v-for="(row, i) in pro.analysisList">
                    <td :key="index+ '_' + ind + '_' +i+'_1'" class="ivu-table-column-center" v-if="!changeValue" :class="{'high-light': (pro.name=='总计'||pro.name=='全部')&&showProject}"><div class="ivu-table-cell"><span>{{row.value|toFixed}}</span></div></td>
                    <td :key="index+ '_' + ind + '_' +i+'_2'" class="ivu-table-column-center" v-if="changeValue" :class="{'high-light': (pro.name=='总计'||pro.name=='全部')&&showProject}"><div class="ivu-table-cell"><span>{{(row.value + row.new_value)|toFixed}}</span></div></td>
                    <td :key="index+ '_' + ind + '_' +i+'_5'" class="ivu-table-column-center" :class="{'high-light': (pro.name=='总计'||pro.name=='全部')&&showProject}"><div class="ivu-table-cell"><span>{{row.expense|toFixed}}</span></div></td>
                    <td :key="index+ '_' + ind + '_' +i+'_3'" class="ivu-table-column-center" :class="{'high-light': (pro.name=='总计'||pro.name=='全部')&&showProject}"><div class="ivu-table-cell"><span>{{row.all_cost|toFixed}} </span></div></td>
                    <td :key="index+ '_' + ind + '_' +i+'_4'" class="ivu-table-column-center light" :class="{'high-light': (pro.name=='总计'||pro.name=='全部')&&showProject}"><div class="ivu-table-cell"><span>{{grossMargin(row.all_cost, row.value, row.new_value)}}</span></div></td>
                  </template>
                </tr>
               </template>
              </template>
            </tbody>
          </table>
        </div>
        <div class="ivu-table-tip" style="display: none;">
          <table cellspacing="0" cellpadding="0" border="0"><tbody><tr><td style="width: 1159px;"><span>暂无筛选结果</span></td></tr></tbody></table>
        </div>
        <div class="ivu-table-fixed" style="width: 380px;">
          <div class="ivu-table-fixed-header">
            <table cellspacing="0" cellpadding="0" border="0" style="width: 380px;">
              <colgroup>
                <col width="100">
                <col width="80">
                <col width="200">
                <template v-for="item in monthLen">
                  <col :key="item+'_1'" width="100">
                  <col :key="item+'_2'" width="100">
                  <col :key="item+'_3'" width="100">
                  <col :key="item+'_4'" width="100">
                </template>
              </colgroup>
                <thead>
                  <tr>
                    <th class="ivu-table-column-center" rowspan="2"><div class="ivu-table-cell"><span class="">部门</span></div></th>
                    <th class="ivu-table-column-center" rowspan="2"><div class="ivu-table-cell"><span class="">负责人</span></div></th>
                    <th class="ivu-table-column-center" rowspan="2"><div class="ivu-table-cell"><span class="">{{showProject?'项目名称':'汇总'}}</span></div></th>
                    <template v-for="item in monthLen">
                      <th :key="item+'_1'" class="ivu-table-column-center" colspan="4" v-if="item==1"><div class="ivu-table-cell"><span class="">汇总</span></div></th>
                      <th :key="item+'_2'" class="ivu-table-column-center" colspan="4" v-else><div class="ivu-table-cell"><span class="">{{item-1}} 月</span></div></th>
                    </template>
                  </tr>
                  <tr>
                    <template v-for="(item, ind) in monthLen">
                      <th :key="ind+'_1'" class="ivu-table-column-center" v-if="!changeValue">
                        <div class="ivu-table-cell"><span class="">产值</span></div>
                      </th>
                      <th :key="ind+'_2'" class="ivu-table-column-center" v-if="changeValue">
                        <div class="ivu-table-cell"><span class="">调整后产值</span></div>
                      </th>
                      <th :key="item+'_5'" class="ivu-table-column-center">
                        <div class="ivu-table-cell"><span class="">项目报销</span></div>
                    </th>
                      <th :key="ind+'_3'" class="ivu-table-column-center">
                        <div class="ivu-table-cell"><span class="">总成本</span></div>
                      </th>
                      <th :key="ind+'_4'" class="ivu-table-column-center">
                        <div class="ivu-table-cell"><span class="">毛利率</span></div>
                      </th>
                    </template>
                  </tr>
                </thead>
                <tbody class="ivu-table-body ivu-table-overflowX">
                  <template v-for="(item, index) in data">
                    <tr :key="index" class="ivu-table-row" :class="{'allcount': item.name=='汇总'}">
                     <td class="ivu-table-column-center" :rowspan="showProject?item.projects.length + 1:2"><div class="ivu-table-cell"><span>{{item.name}}</span></div></td>
                     <td class="ivu-table-column-center" :rowspan="showProject?item.projects.length + 1:2"><div class="ivu-table-cell"><span v-if="item.director">{{item.director.username}}</span></div></td>
                   </tr>
                  <template v-for="(pro, ind) in item.projects">
                   <tr class="ivu-table-row" :class="{'allcount': item.name=='汇总'}" :key="index + '_' + ind" v-if="pro.name =='全部' || pro.name =='总计' || showProject">
                     <td class="ivu-table-column-center" :class="{'high-light': (pro.name=='总计'||pro.name=='全部')&&showProject}"><div class="ivu-table-cell"><span>{{pro.name}}</span></div></td>
                     <td class="ivu-table-column-center" v-if="!changeValue" :class="{'high-light': (pro.name=='总计'||pro.name=='全部')&&showProject}"><div class="ivu-table-cell"><span>{{pro.total_value|toFixed}} </span></div></td>
                     <td class="ivu-table-column-center" v-if="changeValue" :class="{'high-light': (pro.name=='总计'||pro.name=='全部')&&showProject}"><div class="ivu-table-cell"><span>{{(pro.total_value + pro.total_new_value)|toFixed}} </span></div></td>
                     <td class="ivu-table-column-center" :class="{'high-light': (pro.name=='总计'||pro.name=='全部')&&showProject}"><div class="ivu-table-cell"><span>{{pro.total_all_cost|toFixed}} </span></div></td>
                     <td class="ivu-table-column-center light" :class="{'high-light': (pro.name=='总计'||pro.name=='全部')&&showProject}"><div class="ivu-table-cell"><span>{{grossMargin(pro.total_all_cost , pro.total_value, pro.total_new_value)}}</span></div></td>
                     <!-- <template v-for="(row, i) in pro.analysisList">
                       <td :key="index + '_' +ind+'_'+i+'_1'" class="ivu-table-hidden" v-if="!changeValue"><div class="ivu-table-cell"><span>{{row.value}} </span></div></td>
                       <td :key="index + '_' +ind+'_'+i+'_2'" class="ivu-table-hidden" v-if="changeValue"><div class="ivu-table-cell"><span>{{row.value + parseFloat(row.new_value)}} </span></div></td>
                       <td :key="index + '_' +ind+'_'+i+'_5'" class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{row.all_cost|toFixed}} </span></div></td>
                       <td :key="index + '_' +ind+'_'+i+'_3'" class="ivu-table-hidden"><div class="ivu-table-cell"><span>{{row.all_cost|toFixed}} </span></div></td>
                       <td :key="index + '_' +ind+'_'+i+'_4'" class="ivu-table-hidden light"><div class="ivu-table-cell"><span>{{grossMargin(row.all_cost, row.value, row.new_value)}} % </span></div></td>
                     </template> -->
                   </tr>
                 </template>
                 </template>
               </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
   </div>
</template>

<script>
import {post} from '../fetch/api'

// const month = date.getMonth()
export default {
  name: 'AnalysisCount',
  props: {
    year: {
      type: String
    },
    data: {
      type: Array || Object
    },
    refresh: Function,
    'on-change': Function
  },
  data () {
    return {
      changeValue: false,
      showProject: true,
      open: false,
      monthLen: 13
    }
  },
  watch: {
  },
  filters: {
    toFixed (v) {
      if (!v) return 0
      return Number(v).toFixed(2)
    }
  },
  mounted () {
  },
  methods: {
    exportData () {
      var dom = document.getElementById('ifile')
      post('users/export/analysis/month', {'year': this.year}).then(res => {
        if (res.status === 'success') {
          this.$Modal.success({
            title: '请求成功',
            content: '正在尝试生成excel数据, 请耐心等待...',
            okText: '关闭'
          })
          dom.src = this.apiPath + `export/analysis/month?cry=${res.cry}`
        }
      })
    },
    lastYear () {
      let year = Number(this.year) - 1
      this.$emit('update:year', String(year))
      this.$emit('on-change', String(year))
    },
    nextYear () {
      let year = Number(this.year) + 1
      this.$emit('update:year', String(year))
      this.$emit('on-change', String(year))
    },
    grossMargin (a, b, c) {
      b = this.changeValue ? (b + c) : b
      if (Number(a) === 0 || Number(b) === 0) return '--'
      return (Number(1 - Number(a) / Number(b)) * 100).toFixed(2) + '%'
    },
    handleChange (year) {
      this.$emit('update:year', year)
    },
    handleOk () {
      this.refresh()
      this.open = !this.open
    },
    handleClick () {
      this.open = !this.open
    }
  }
}
</script>

<style scoped>
.ivu-table-cell {
  padding-left: 5px;
  padding-right: 5px;
}
.ivu-table td.light{background-color: #f7f7f7}
.ivu-table td.high-light{background-color: #cae6fd}
.ivu-table .allcount td{background-color: #000}
.ivu-table .allcount td{background-color: #eee}
</style>
